// IMPORTANT: This file is auto generated from createSVGImportFromMeta.ts
// Any changes you make to this file here will be overwritten.

import { AppIcons, Icons, SVGs } from '@inmoment/the-kitchen';

interface Meta<T extends string> {
  name: T;
  pretty: string;
  category: string;
  tags: string[];
}

export const _AppIconMeta: Meta<AppIcons>[] = [
  { name: 'admin', pretty: 'Admin', category: '', tags: ['appicon'] },
  { name: 'admin_white', pretty: 'Admin White', category: '', tags: ['appicon'] },
  { name: 'announcements', pretty: 'Announcements', category: '', tags: ['appicon'] },
  { name: 'announcements_white', pretty: 'Announcements White', category: '', tags: ['appicon'] },
  { name: 'benchmark', pretty: 'Benchmark', category: '', tags: ['appicon'] },
  { name: 'benchmark_white', pretty: 'Benchmark White', category: '', tags: ['appicon'] },
  { name: 'campaign_insights', pretty: 'Campaign Insights', category: '', tags: ['appicon'] },
  { name: 'campaign_insights_white', pretty: 'Campaign Insights White', category: '', tags: ['appicon'] },
  { name: 'case_management', pretty: 'Case Management', category: '', tags: ['appicon'] },
  { name: 'case_management_new', pretty: 'Case Management New', category: '', tags: ['appicon'] },
  { name: 'case_management_new_white', pretty: 'Case Management New White', category: '', tags: ['appicon'] },
  { name: 'case_management_white', pretty: 'Case Management White', category: '', tags: ['appicon'] },
  { name: 'coach_location', pretty: 'Coach Location', category: '', tags: ['appicon'] },
  { name: 'coach', pretty: 'Coach', category: '', tags: ['appicon'] },
  { name: 'coach_white', pretty: 'Coach White', category: '', tags: ['appicon'] },
  { name: 'cx_analyst', pretty: 'CX Analyst', category: '', tags: ['appicon'] },
  { name: 'cx_analyst_white', pretty: 'CX Analyst White', category: '', tags: ['appicon'] },
  { name: 'cxic_admin', pretty: 'CXIC Admin', category: '', tags: ['appicon'] },
  { name: 'cxic_reporting', pretty: 'CXIC Reporting', category: '', tags: ['appicon'] },
  { name: 'dashboard', pretty: 'Dashboard', category: '', tags: ['appicon'] },
  { name: 'dashboard_white', pretty: 'Dashboard White', category: '', tags: ['appicon'] },
  { name: 'data_exploration', pretty: 'Data Exploration', category: '', tags: ['appicon'] },
  { name: 'data_exploration_white', pretty: 'Data Exploration White', category: '', tags: ['appicon'] },
  { name: 'discover_insights', pretty: 'Discover Insights', category: '', tags: ['appicon'] },
  { name: 'discover_insights_white', pretty: 'Discover Insights White', category: '', tags: ['appicon'] },
  { name: 'discover', pretty: 'Discover', category: '', tags: ['appicon'] },
  { name: 'discover_white', pretty: 'Discover White', category: '', tags: ['appicon'] },
  { name: 'exec_reporting', pretty: 'Exec Reporting', category: '', tags: ['appicon'] },
  { name: 'exec_reporting_white', pretty: 'Exec Reporting White', category: '', tags: ['appicon'] },
  { name: 'explore', pretty: 'Explore', category: '', tags: ['appicon'] },
  { name: 'explore_white', pretty: 'Explore White', category: '', tags: ['appicon'] },
  { name: 'field_reporting', pretty: 'Field Reporting', category: '', tags: ['appicon'] },
  { name: 'field_reporting_white', pretty: 'Field Reporting White', category: '', tags: ['appicon'] },
  { name: 'home', pretty: 'Home', category: '', tags: ['appicon'] },
  { name: 'home_white', pretty: 'Home White', category: '', tags: ['appicon'] },
  { name: 'invitation_management', pretty: 'Invitation Management', category: '', tags: ['appicon'] },
  { name: 'invitation_management_white', pretty: 'Invitation Management White', category: '', tags: ['appicon'] },
  { name: 'kitchen', pretty: 'Kitchen', category: '', tags: ['appicon'] },
  { name: 'market_survey', pretty: 'Market Survey', category: '', tags: ['appicon'] },
  { name: 'market_survey_white', pretty: 'Market Survey White', category: '', tags: ['appicon'] },
  { name: 'mcx', pretty: 'Mcx', category: '', tags: ['appicon'] },
  { name: 'mcx_white', pretty: 'Mcx White', category: '', tags: ['appicon'] },
  { name: 'metrics', pretty: 'Metrics', category: '', tags: ['appicon'] },
  { name: 'metrics_white', pretty: 'Metrics White', category: '', tags: ['appicon'] },
  { name: 'microsurvey', pretty: 'Microsurvey', category: '', tags: ['appicon'] },
  { name: 'microsurvey_white', pretty: 'Microsurvey White', category: '', tags: ['appicon'] },
  { name: 'moments', pretty: 'Moments', category: '', tags: ['appicon'] },
  { name: 'moments_white', pretty: 'Moments White', category: '', tags: ['appicon'] },
  { name: 'placeholder', pretty: 'Placeholder', category: '', tags: ['appicon'] },
  { name: 'placeholder_white', pretty: 'Placeholder White', category: '', tags: ['appicon'] },
  { name: 'reporting', pretty: 'Reporting', category: '', tags: ['appicon'] },
  { name: 'reporting_white', pretty: 'Reporting White', category: '', tags: ['appicon'] },
  { name: 'research', pretty: 'Research', category: '', tags: ['appicon'] },
  { name: 'research_white', pretty: 'Research White', category: '', tags: ['appicon'] },
  { name: 'resolve', pretty: 'Resolve', category: '', tags: ['appicon'] },
  { name: 'resolve_white', pretty: 'Resolve White', category: '', tags: ['appicon'] },
  { name: 'review_trackers', pretty: 'Review Trackers', category: '', tags: ['appicon'] },
  { name: 'review_trackers_white', pretty: 'Review Trackers White', category: '', tags: ['appicon'] },
  { name: 'seo', pretty: 'SEO', category: '', tags: ['appicon'] },
  { name: 'seo_white', pretty: 'SEO White', category: '', tags: ['appicon'] },
  { name: 'spotlight', pretty: 'Spotlight', category: '', tags: ['appicon'] },
  { name: 'spotlight_white', pretty: 'Spotlight White', category: '', tags: ['appicon'] },
  { name: 'studio', pretty: 'Studio', category: '', tags: ['appicon'] },
  { name: 'studio_white', pretty: 'Studio White', category: '', tags: ['appicon'] },
  { name: 'summary', pretty: 'Summary', category: '', tags: ['appicon'] },
  { name: 'summary_white', pretty: 'Summary White', category: '', tags: ['appicon'] },
  { name: 'survey', pretty: 'Survey', category: '', tags: ['appicon'] },
  { name: 'survey_white', pretty: 'Survey White', category: '', tags: ['appicon'] },
  { name: 'text_analytics', pretty: 'Text Analytics', category: '', tags: ['appicon'] },
  { name: 'text_analytics_white', pretty: 'Text Analytics White', category: '', tags: ['appicon'] },
  { name: 'watch_list', pretty: 'Watch List', category: '', tags: ['appicon'] },
  { name: 'watch_list_white', pretty: 'Watch List White', category: '', tags: ['appicon'] },
  { name: 'workflow', pretty: 'Workflow', category: '', tags: ['appicon'] },
];

export const _SVGMeta: Meta<SVGs>[] = [
  {
    name: 'binoculars',
    pretty: 'Binoculars',
    category: 'illustration',
    tags: ['svg', 'sight', 'see', 'vision', 'scenery', 'scope', 'nature', 'glass'],
  },
  { name: 'booking', pretty: 'Booking', category: 'company', tags: ['svg', 'logo', 'mark'] },
  { name: 'browser_refresh', pretty: 'Browser Refresh', category: 'illustration', tags: ['svg', 'arrows', 'window', 'text', 'auto', 'cycle'] },
  {
    name: 'burger',
    pretty: 'Burger',
    category: 'illustration',
    tags: ['svg', 'food', 'restaurant', 'dinner', 'meat', 'american', 'lettuce', 'patty', 'cheese'],
  },
  { name: 'camping', pretty: 'Camping', category: 'illustration', tags: ['svg', 'outdoors', 'woods', 'trees', 'waiting', 'tent', 'pine', 'door'] },
  {
    name: 'car',
    pretty: 'Car',
    category: 'illustration',
    tags: [
      'svg',
      'vehicle',
      'transport',
      'engine',
      'headlights',
      'grill',
      'glass',
      'windshield',
      'automobile',
      'van',
      'suv',
      'license plate',
      'wheel',
      'tire',
    ],
  },
  {
    name: 'category_cycle',
    pretty: 'Category Cycle',
    category: 'illustration',
    tags: ['svg', 'circle', 'connection', 'dots', 'triangle', 'group', 'section', 'surrounded', 'lines'],
  },
  {
    name: 'category',
    pretty: 'Category',
    category: 'illustration',
    tags: ['svg', 'circle', 'connection', 'dots', 'triangle', 'group', 'section', 'surrounded', 'lines', 'arrow'],
  },
  {
    name: 'celebration',
    pretty: 'Celebration',
    category: 'illustration',
    tags: ['svg', 'party', 'confetti', 'fun', 'joy', 'happy', 'blast', 'streamers', 'paper'],
  },
  {
    name: 'certificate',
    pretty: 'Certificate',
    category: 'illustration',
    tags: ['svg', 'award', 'diploma', 'ribbon', 'first place', 'competency', 'clipboard', 'form'],
  },
  {
    name: 'chart_double',
    pretty: 'Chart Double',
    category: 'illustration',
    tags: ['svg', 'growth', 'data', 'graph', 'whiteboard', 'up', 'positive', 'multiple'],
  },
  { name: 'chart', pretty: 'Chart', category: 'illustration', tags: ['svg', 'growth', 'data', 'graph', 'whiteboard', 'up', 'positive'] },
  {
    name: 'clapper_board',
    pretty: 'Clapper Board',
    category: 'illustration',
    tags: ['svg', 'movies', 'action', 'start', 'film', 'creativity', 'tv show'],
  },
  {
    name: 'clipboard_planning',
    pretty: 'Clipboard Planning',
    category: 'illustration',
    tags: ['svg', 'strategy', 'play', 'move', 'arrow', 'x', 'o', 'execution', 'game', 'football', 'basketball', 'sports'],
  },
  {
    name: 'clothes_shopping',
    pretty: 'Clothes Shopping',
    category: 'illustration',
    tags: ['svg', 'store', 'purchase', 'purchasing', 'buying', 'spending', 'gift', 'bag', 'purse', 'hanger', 'handle'],
  },
  {
    name: 'clothing_hung',
    pretty: 'Clothing Hung',
    category: 'illustration',
    tags: ['svg', 'hanger', 't-shirt', 'pocket', 'short sleeves', 'fabric'],
  },
  {
    name: 'cogs',
    pretty: 'Cogs',
    category: 'illustration',
    tags: ['svg', 'configure', 'moving', 'plan', 'action', 'arrow', 'gears', 'settings', 'engineering', 'movement'],
  },
  { name: 'colorful_wave', pretty: 'Colorful Wave', category: 'background', tags: ['svg', 'blue'] },
  { name: 'crane_illustration', pretty: 'Crane Illustration', category: '', tags: ['svg'] },
  {
    name: 'crystal_ball',
    pretty: 'Crystal Ball',
    category: 'illustration',
    tags: ['svg', 'prediction', 'future', 'past', 'glitter', 'light', 'psychic'],
  },
  { name: 'cx_background', pretty: 'CX Background', category: 'background', tags: ['svg', 'customer', 'blue', 'clouds'] },
  { name: 'cx_edit_dialog_left_bg', pretty: 'CX Edit Dialog Left BG', category: 'background', tags: ['svg', 'background', 'waves'] },
  {
    name: 'discount_tag',
    pretty: 'Discount Tag',
    category: 'illustration',
    tags: ['svg', 'sale', 'cheap', 'free', 'price', 'percent', 'label', 'clearance'],
  },
  { name: 'display_ab_running', pretty: 'Display AB Running', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_app', pretty: 'Display App', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_banner', pretty: 'Display Banner', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_bottom_center', pretty: 'Display Bottom Center', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_bottom_left', pretty: 'Display Bottom Left', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_bottom_right', pretty: 'Display Bottom Right', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_default', pretty: 'Display Default', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_embedded', pretty: 'Display Embedded', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_middle_center', pretty: 'Display Middle Center', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_middle_left', pretty: 'Display Middle Left', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_middle_right', pretty: 'Display Middle Right', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_popup', pretty: 'Display Popup', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  {
    name: 'display_rating',
    pretty: 'Display Rating',
    category: 'illustration',
    tags: ['svg', 'screen', 'visual', 'demo', 'checkmark', 'window', 'popup', 'website'],
  },
  { name: 'display_tab', pretty: 'Display Tab', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_top_center', pretty: 'Display Top Center', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_top_left', pretty: 'Display Top Left', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_top_right', pretty: 'Display Top Right', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'display_window', pretty: 'Display Window', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  {
    name: 'document_okay',
    pretty: 'Document Okay',
    category: 'illustration',
    tags: ['svg', 'page', 'positive', 'good', 'checkmark', 'paper', 'success'],
  },
  {
    name: 'document_section',
    pretty: 'Document Section',
    category: 'illustration',
    tags: ['svg', 'page', 'paper', 'highlight', 'arrow', 'lists', 'selected', 'grid'],
  },
  {
    name: 'email',
    pretty: 'Email',
    category: 'illustration',
    tags: ['svg', 'email', 'mail', 'letter', 'postage', 'postal', 'paper', 'inbox', 'envelope', 'message'],
  },
  {
    name: 'employee_engagement',
    pretty: 'Employee Engagement',
    category: 'illustration',
    tags: ['svg', 'woman', 'female', 'people', 'person', 'swap', 'arrows', 'human', 'user', 'customer'],
  },
  { name: 'ex_background', pretty: 'EX Background', category: 'background', tags: ['svg', 'experience', 'purple', 'clouds'] },
  { name: 'ex_edit_dialog_left_bg', pretty: 'EX Edit Dialog Left BG', category: 'background', tags: ['svg', 'background', 'waves'] },
  { name: 'facebook', pretty: 'Facebook', category: 'company', tags: ['svg', 'logo'] },
  { name: 'file_upload', pretty: 'File Upload', category: '', tags: ['svg'] },
  { name: 'four_square', pretty: 'Four Square', category: 'company', tags: ['svg', 'logo'] },
  {
    name: 'fries',
    pretty: 'Fries',
    category: 'illustration',
    tags: ['svg', 'food', 'restaurant', 'dinner', 'french', 'potato', 'take-out', 'fast casual'],
  },
  { name: 'gift_card', pretty: 'Gift Card', category: 'illustration', tags: ['svg', 'money', 'credit', 'survey', 'present', 'dollar', 'cash'] },
  { name: 'globe', pretty: 'Globe', category: 'illustration', tags: ['svg', 'earth', 'planet', 'world', 'continents', 'motion'] },
  { name: 'google', pretty: 'Google', category: 'company', tags: ['svg', 'logo'] },
  {
    name: 'graph_message',
    pretty: 'Graph Message',
    category: 'illustration',
    tags: ['svg', 'display', 'data', 'growth', 'text', 'messaging', 'comment', 'speech', 'up', 'chart'],
  },
  { name: 'graph', pretty: 'Graph', category: 'illustration', tags: ['svg', 'data', 'growth', 'success', 'arrow', 'whiteboard'] },
  {
    name: 'graph_mobile_web',
    pretty: 'Graph Mobile Web',
    category: 'illustration',
    tags: ['svg', 'display', 'data', 'growth', 'text', 'messaging', 'mobile', 'comment', 'speech', 'up', 'chart'],
  },
  {
    name: 'graph_progress_search',
    pretty: 'Graph Progress Search',
    category: 'illustration',
    tags: ['svg', 'display', 'data', 'growth', 'magnifying glass', 'up', 'chart', 'positive', 'window'],
  },
  {
    name: 'graph_search',
    pretty: 'Graph Search',
    category: 'illustration',
    tags: ['svg', 'display', 'data', 'growth', 'magnifying glass', 'up', 'chart', 'positive', 'window'],
  },
  {
    name: 'graph_web',
    pretty: 'Graph Web',
    category: 'illustration',
    tags: ['svg', 'display', 'data', 'growth', 'chart', 'computer', 'desktop', 'window'],
  },
  { name: 'groceries', pretty: 'Groceries', category: 'illustration', tags: ['svg', 'food', 'bread', 'apple', 'milk', 'bag', 'label'] },
  {
    name: 'group',
    pretty: 'Group',
    category: 'illustration',
    tags: ['svg', 'people', 'man', 'woman', 'male', 'female', 'together', 'users', 'community', 'human', 'customers', 'faces'],
  },
  {
    name: 'hand_embrace',
    pretty: 'Hand Embrace',
    category: 'illustration',
    tags: ['svg', 'teamwork', 'goals', 'strength', 'together', 'collaboration', 'collaberate', 'arm wrestle', 'hands', 'grasp'],
  },
  { name: 'hand_favorite', pretty: 'Hand Favorite', category: 'illustration', tags: ['svg', 'heart', 'love', 'save', 'give', 'charity', 'share'] },
  {
    name: 'hand_money',
    pretty: 'Hand Money',
    category: 'illustration',
    tags: ['svg', 'cash', 'earnings', 'pay', 'give', 'dollar sign', 'transaction'],
  },
  {
    name: 'hand_security',
    pretty: 'Hand Security',
    category: 'illustration',
    tags: ['svg', 'secure', 'data', 'protect', 'store', 'encrypt', 'shield', 'plus', 'strenthen'],
  },
  {
    name: 'hand_shake',
    pretty: 'Hand Shake',
    category: 'illustration',
    tags: ['svg', 'teamwork', 'together', 'collaboration', 'collaberate', 'greetings', 'meeting', 'careers', 'hands', 'watch', 'time'],
  },
  { name: 'health_grades', pretty: 'Health Grades', category: 'company', tags: ['svg', 'logo', 'mark'] },
  {
    name: 'hospital',
    pretty: 'Hospital',
    category: 'illustration',
    tags: ['svg', 'building', 'medicine', 'medical', 'injury', 'plus', 'door', 'emergency'],
  },
  {
    name: 'human_message',
    pretty: 'Human Message',
    category: 'illustration',
    tags: ['svg', 'female', 'woman', 'person', 'messaging', 'chat', 'customer', 'listen', 'user', 'human'],
  },
  {
    name: 'human_okay',
    pretty: 'Human Okay',
    category: 'illustration',
    tags: ['svg', 'female', 'woman', 'person', 'success', 'customer', 'chechmark', 'user', 'human'],
  },
  { name: 'inmoment_favicon_blue', pretty: 'Inmoment Favicon Blue', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_favicon_magenta', pretty: 'Inmoment Favicon Magenta', category: '', tags: ['svg'] },
  { name: 'inmoment_favicon_orca', pretty: 'Inmoment Favicon Orca', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_favicon_purple', pretty: 'Inmoment Favicon Purple', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_favicon_teal', pretty: 'Inmoment Favicon Teal', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_favicon_white', pretty: 'Inmoment Favicon White', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_main_full_color', pretty: 'Inmoment Main Full Color', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_main_white', pretty: 'Inmoment Main White', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_powered_by_horizontal_full_color', pretty: 'Inmoment Powered BY Horizontal Full Color', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_powered_by_horizontal_gray', pretty: 'Inmoment Powered BY Horizontal Gray', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_powered_by_horizontal_orca', pretty: 'Inmoment Powered BY Horizontal Orca', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_powered_by_horizontal_white', pretty: 'Inmoment Powered BY Horizontal White', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_powered_by_vertical_full_color', pretty: 'Inmoment Powered BY Vertical Full Color', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_powered_by_vertical_gray', pretty: 'Inmoment Powered BY Vertical Gray', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_powered_by_vertical_orca', pretty: 'Inmoment Powered BY Vertical Orca', category: 'inmoment', tags: ['svg'] },
  { name: 'inmoment_powered_by_vertical_white', pretty: 'Inmoment Powered BY Vertical White', category: 'inmoment', tags: ['svg'] },
  { name: 'instagram', pretty: 'Instagram', category: 'company', tags: ['svg', 'logo', 'mark'] },
  {
    name: 'international',
    pretty: 'International',
    category: 'illustration',
    tags: ['svg', 'globe', 'earth', 'airports', 'travel', 'world', 'connect', 'network', 'ethernet', 'wifi', 'internet'],
  },
  { name: 'late_rooms', pretty: 'Late Rooms', category: 'company', tags: ['svg', 'logo', 'mark'] },
  { name: 'location_map', pretty: 'Location Map', category: 'illustration', tags: ['svg', 'gps', 'place', 'geo', 'pin', 'circle', 'find', 'area'] },
  { name: 'location', pretty: 'Location', category: 'illustration', tags: ['svg', 'gps', 'places', 'map', 'travel', 'find', 'pin', 'road'] },
  {
    name: 'message_group',
    pretty: 'Message Group',
    category: 'illustration',
    tags: ['svg', 'text', 'texting', 'messaging', 'chat', 'multi', 'bubble', 'speech', 'listen', 'talk'],
  },
  {
    name: 'message',
    pretty: 'Message',
    category: 'illustration',
    tags: ['svg', 'text', 'texting', 'messaging', 'chat', 'multi', 'bubbles', 'speech', 'listen', 'talk', 'dots'],
  },
  {
    name: 'mobile_touch',
    pretty: 'Mobile Touch',
    category: 'illustration',
    tags: ['svg', 'screen', 'tap', 'press', 'click', 'drag', 'press', 'mobile', 'finger', 'hand', 'cell phone'],
  },
  { name: 'money', pretty: 'Money', category: 'illustration', tags: ['svg', 'cash', 'coins', 'pay', 'bills', 'dollars', 'add', 'more', 'currency'] },
  { name: 'mx_background', pretty: 'MX Background', category: 'background', tags: ['svg', 'marketing', 'green', 'teal', 'clouds'] },
  { name: 'mx_edit_dialog_left_bg', pretty: 'MX Edit Dialog Left BG', category: 'background', tags: ['svg', 'background', 'waves'] },
  { name: 'negative_sentiment_filled', pretty: 'Negative Sentiment Filled', category: 'sentiment', tags: ['svg', 'frowny', 'face', 'red', 'sad'] },
  { name: 'negative_sentiment', pretty: 'Negative Sentiment', category: 'sentiment', tags: ['svg', 'frowny', 'face', 'red', 'sad'] },
  {
    name: 'negative_sentiment_outlined',
    pretty: 'Negative Sentiment Outlined',
    category: 'sentiment',
    tags: ['svg', 'frowny', 'face', 'red', 'sad'],
  },
  {
    name: 'neutral_sentiment_filled',
    pretty: 'Neutral Sentiment Filled',
    category: 'sentiment',
    tags: ['svg', 'indifferent', 'face', 'grey', 'content'],
  },
  { name: 'neutral_sentiment', pretty: 'Neutral Sentiment', category: 'sentiment', tags: ['svg', 'indifferent', 'face', 'grey', 'content'] },
  {
    name: 'neutral_sentiment_outlined',
    pretty: 'Neutral Sentiment Outlined',
    category: 'sentiment',
    tags: ['svg', 'indifferent', 'face', 'grey', 'content'],
  },
  {
    name: 'no',
    pretty: 'No',
    category: 'illustration',
    tags: ['svg', 'decline', 'failure', 'error', 'problems', 'negative', 'cancel', 'x', 'close'],
  },
  { name: 'none', pretty: 'None', category: 'illustration', tags: ['svg', 'empty', 'hidden', 'invisible', 'disallowed', 'line', 'discontinued'] },
  { name: 'numbers_graphic', pretty: 'Numbers Graphic', category: 'illustration', tags: ['svg'] },
  { name: 'open_table', pretty: 'Open Table', category: 'company', tags: ['svg', 'logo'] },
  { name: 'other', pretty: 'Other', category: 'illustration', tags: ['svg', 'pencil', 'writing', 'notes'] },
  { name: 'outbound_call', pretty: 'Outbound Call', category: 'illustration', tags: ['svg', 'phone', 'communication', 'communicate'] },
  { name: 'outbound_email', pretty: 'Outbound Email', category: 'illustration', tags: ['svg'] },
  { name: 'people_boy', pretty: 'People Boy', category: '', tags: ['svg', 'male', 'man', 'person', 'guy', 'mobile', 'phone', 'picture'] },
  { name: 'people_girl', pretty: 'People Girl', category: '', tags: ['svg', 'woman', 'female', 'dancing', 'presenting'] },
  { name: 'person_favorite', pretty: 'Person Favorite', category: 'illustration', tags: ['svg', 'male', 'man', 'heart', 'love'] },
  { name: 'planet_1', pretty: 'Planet 1', category: '', tags: ['svg', 'space', '404', 'error', 'page'] },
  { name: 'planet_2', pretty: 'Planet 2', category: '', tags: ['svg', 'space', '404', 'error', 'page'] },
  { name: 'plus', pretty: 'Plus', category: 'illustration', tags: ['svg'] },
  { name: 'positive_sentiment_filled', pretty: 'Positive Sentiment Filled', category: 'sentiment', tags: ['svg', 'happy', 'face', 'blue'] },
  { name: 'positive_sentiment', pretty: 'Positive Sentiment', category: 'sentiment', tags: ['svg', 'happy', 'face', 'blue'] },
  { name: 'positive_sentiment_outlined', pretty: 'Positive Sentiment Outlined', category: 'sentiment', tags: ['svg', 'happy', 'face', 'blue'] },
  {
    name: 'post_transaction',
    pretty: 'Post Transaction',
    category: 'illustration',
    tags: ['svg', 'credit', 'debit', 'card', 'purchase', 'buying', 'spending'],
  },
  {
    name: 'product_offer',
    pretty: 'Product Offer',
    category: 'illustration',
    tags: ['svg', 'store', 'purchase', 'purchasing', 'buying', 'spending', 'gift', 'bag', 'purse'],
  },
  { name: 'ramen', pretty: 'Ramen', category: 'illustration', tags: ['svg', 'food', 'japanese', 'bowl', 'soup'] },
  { name: 'receipt', pretty: 'Receipt', category: 'illustration', tags: ['svg', 'paper', 'purchase', 'record'] },
  { name: 'relationship', pretty: 'Relationship', category: 'illustration', tags: ['svg', 'hand'] },
  { name: 'secret_code_graphic', pretty: 'Secret Code Graphic', category: 'illustration', tags: ['svg', 'password', 'security', 'encryption'] },
  { name: 'security', pretty: 'Security', category: 'illustration', tags: ['svg', 'lock', 'key', 'password', 'protection', 'encryption'] },
  { name: 'skew_clock', pretty: 'Skew Clock', category: 'skew', tags: ['svg', 'cloud', 'time', 'minutes', 'seconds', 'hours'] },
  { name: 'skew_desktop_1', pretty: 'Skew Desktop 1', category: 'skew', tags: ['svg', 'display', 'cloud', 'mobile', 'web'] },
  { name: 'skew_desktop_2', pretty: 'Skew Desktop 2', category: 'skew', tags: ['svg', 'display', 'cloud', 'mobile', 'web'] },
  { name: 'skew_desktop_3', pretty: 'Skew Desktop 3', category: 'skew', tags: ['svg', 'display', 'cloud', 'mobile', 'web'] },
  { name: 'skew_phone_1', pretty: 'Skew Phone 1', category: 'skew', tags: ['svg', 'display', 'mobile'] },
  { name: 'skew_phone_2', pretty: 'Skew Phone 2', category: 'skew', tags: ['svg', 'display', 'mobile'] },
  { name: 'slide_widget_background', pretty: 'Slide Widget Background', category: '', tags: ['svg'] },
  { name: 'sms', pretty: 'Sms', category: 'illustration', tags: ['svg', 'texting', 'messaging', 'message', 'chat', 'mobile', 'phone', 'screen'] },
  { name: 'spoof_2', pretty: 'Spoof 2', category: '', tags: ['svg'] },
  { name: 'spoof', pretty: 'Spoof', category: '', tags: ['svg'] },
  { name: 'star_circle', pretty: 'Star Circle', category: '', tags: ['svg', 'space', '404', 'error', 'page'] },
  { name: 'star_pointed', pretty: 'Star Pointed', category: '', tags: ['svg', 'space', '404', 'error', 'page'] },
  { name: 'stethoscope', pretty: 'Stethoscope', category: 'illustration', tags: ['svg', 'doctors', 'tool', 'medicine', 'medical', 'checkup'] },
  {
    name: 'survey',
    pretty: 'Survey',
    category: '',
    tags: ['svg', 'survey', 'form', 'list', 'message', 'todo', 'checklist', 'task', 'items', 'bullets', 'browser', 'web', 'interface', 'website'],
  },
  { name: 'target', pretty: 'Target', category: 'illustration', tags: ['svg', 'bow', 'arrow', 'practice', 'archery', 'goal', 'achievement'] },
  { name: 'thumbs_up', pretty: 'Thumbs Up', category: 'illustration', tags: ['svg', 'like', 'upvote'] },
  { name: 'ticket', pretty: 'Ticket', category: 'illustration', tags: ['svg', 'movie', 'train', 'airplane', 'entry'] },
  { name: 'timeout_survey', pretty: 'Timeout Survey', category: 'illustration', tags: ['svg', 'survey', 'timeout', 'time', 'hourglass'] },
  { name: 'trip_advisor', pretty: 'Trip Advisor', category: 'company', tags: ['svg', 'logo'] },
  {
    name: 'trophy',
    pretty: 'Trophy',
    category: 'illustration',
    tags: ['svg', 'winner', 'award', 'star', 'placement', 'victory', 'success', 'achievement'],
  },
  { name: 'trust_pilot', pretty: 'Trust Pilot', category: 'company', tags: ['svg', 'logo'] },
  { name: 'twitter', pretty: 'Twitter', category: 'company', tags: ['svg', 'logo'] },
  { name: 'user_categories_complete', pretty: 'User Categories Complete', category: 'illustration', tags: ['svg', 'group'] },
  { name: 'user_categories', pretty: 'User Categories', category: 'illustration', tags: ['svg', 'group'] },
  { name: 'user_cycle', pretty: 'User Cycle', category: 'illustration', tags: ['svg'] },
  { name: 'video', pretty: 'Video', category: 'illustration', tags: ['svg', 'play', 'media'] },
  { name: 'vitals', pretty: 'Vitals', category: 'company', tags: ['svg', 'logo'] },
  {
    name: 'voice_of_employee',
    pretty: 'Voice Of Employee',
    category: 'illustration',
    tags: ['svg', 'man', 'male', 'messaging', 'person', 'chat', 'texting'],
  },
  { name: 'web', pretty: 'Web', category: 'illustration', tags: ['svg', 'display'] },
  { name: 'window_bank', pretty: 'Window Bank', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'window_banner_above', pretty: 'Window Banner Above', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'window_banner_inline', pretty: 'Window Banner Inline', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'window_banner', pretty: 'Window Banner', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'window_default', pretty: 'Window Default', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'window_embedded', pretty: 'Window Embedded', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'window_feedback_default', pretty: 'Window Feedback Default', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'window_popup', pretty: 'Window Popup', category: 'demo', tags: ['svg', 'screen', 'visual', 'demo'] },
  { name: 'xi_icon', pretty: 'XI Icon', category: 'InMoment Logos', tags: ['svg', 'logo'] },
  { name: 'yelp', pretty: 'Yelp', category: 'company', tags: ['svg', 'logo'] },
  { name: 'yes', pretty: 'Yes', category: 'illustration', tags: ['svg', 'positive', 'agreeable', 'agreement', 'success'] },
  { name: 'zomato', pretty: 'Zomato', category: 'company', tags: ['svg', 'logo'] },
];

export const _IconMeta: Meta<Icons>[] = [
  { name: 'ab_testing', pretty: 'AB Testing', category: '', tags: ['icon'] },
  { name: 'account_filled', pretty: 'Account Filled', category: '', tags: ['icon'] },
  { name: 'account', pretty: 'Account', category: '', tags: ['icon'] },
  { name: 'action_planning_filled', pretty: 'Action Planning Filled', category: '', tags: ['icon'] },
  { name: 'action_planning', pretty: 'Action Planning', category: '', tags: ['icon'] },
  { name: 'add_circle_filled', pretty: 'Add Circle Filled', category: '', tags: ['icon'] },
  { name: 'add_circle', pretty: 'Add Circle', category: '', tags: ['icon'] },
  { name: 'analytics_filled', pretty: 'Analytics Filled', category: '', tags: ['icon'] },
  { name: 'analytics', pretty: 'Analytics', category: '', tags: ['icon'] },
  { name: 'anomaly_detection_filled', pretty: 'Anomaly Detection Filled', category: '', tags: ['icon'] },
  { name: 'anomaly_detection', pretty: 'Anomaly Detection', category: '', tags: ['icon'] },
  { name: 'anomaly', pretty: 'Anomaly', category: '', tags: ['icon'] },
  { name: 'answer_distribution_filled', pretty: 'Answer Distribution Filled', category: '', tags: ['icon'] },
  { name: 'answer_distribution', pretty: 'Answer Distribution', category: '', tags: ['icon'] },
  { name: 'app_admin_filled', pretty: 'App Admin Filled', category: '', tags: ['icon'] },
  { name: 'app_admin', pretty: 'App Admin', category: '', tags: ['icon'] },
  { name: 'app_announcements_filled', pretty: 'App Announcements Filled', category: '', tags: ['icon'] },
  { name: 'app_announcements', pretty: 'App Announcements', category: '', tags: ['icon'] },
  { name: 'app_benchmark_filled', pretty: 'App Benchmark Filled', category: '', tags: ['icon'] },
  { name: 'app_benchmark', pretty: 'App Benchmark', category: '', tags: ['icon'] },
  { name: 'app_campaign_insights_filled', pretty: 'App Campaign Insights Filled', category: '', tags: ['icon'] },
  { name: 'app_campaign_insights', pretty: 'App Campaign Insights', category: '', tags: ['icon'] },
  { name: 'app_case_management_filled', pretty: 'App Case Management Filled', category: '', tags: ['icon'] },
  { name: 'app_case_management', pretty: 'App Case Management', category: '', tags: ['icon'] },
  { name: 'app_case_management_new_filled', pretty: 'App Case Management New Filled', category: '', tags: ['icon'] },
  { name: 'app_case_management_new', pretty: 'App Case Management New', category: '', tags: ['icon'] },
  { name: 'app_coach_filled', pretty: 'App Coach Filled', category: '', tags: ['icon'] },
  { name: 'app_coach', pretty: 'App Coach', category: '', tags: ['icon'] },
  { name: 'app_cx_analyst_filled', pretty: 'App CX Analyst Filled', category: '', tags: ['icon'] },
  { name: 'app_cx_analyst', pretty: 'App CX Analyst', category: '', tags: ['icon'] },
  { name: 'app_data_exploration_filled', pretty: 'App Data Exploration Filled', category: '', tags: ['icon'] },
  { name: 'app_data_exploration', pretty: 'App Data Exploration', category: '', tags: ['icon'] },
  { name: 'app_discover_filled', pretty: 'App Discover Filled', category: '', tags: ['icon'] },
  { name: 'app_discover', pretty: 'App Discover', category: '', tags: ['icon'] },
  { name: 'app_exec_reporting_filled', pretty: 'App Exec Reporting Filled', category: '', tags: ['icon'] },
  { name: 'app_exec_reporting', pretty: 'App Exec Reporting', category: '', tags: ['icon'] },
  { name: 'app_explore_filled', pretty: 'App Explore Filled', category: '', tags: ['icon'] },
  { name: 'app_explore', pretty: 'App Explore', category: '', tags: ['icon'] },
  { name: 'app_field_reporting_filled', pretty: 'App Field Reporting Filled', category: '', tags: ['icon'] },
  { name: 'app_field_reporting', pretty: 'App Field Reporting', category: '', tags: ['icon'] },
  { name: 'app_home_filled', pretty: 'App Home Filled', category: '', tags: ['icon'] },
  { name: 'app_home', pretty: 'App Home', category: '', tags: ['icon'] },
  { name: 'app_market_survey_filled', pretty: 'App Market Survey Filled', category: '', tags: ['icon'] },
  { name: 'app_market_survey', pretty: 'App Market Survey', category: '', tags: ['icon'] },
  { name: 'app_mcx_filled', pretty: 'App Mcx Filled', category: '', tags: ['icon'] },
  { name: 'app_mcx', pretty: 'App Mcx', category: '', tags: ['icon'] },
  { name: 'app_metrics_filled', pretty: 'App Metrics Filled', category: '', tags: ['icon'] },
  { name: 'app_metrics', pretty: 'App Metrics', category: '', tags: ['icon'] },
  { name: 'app_microsurvey_filled', pretty: 'App Microsurvey Filled', category: '', tags: ['icon'] },
  { name: 'app_microsurvey', pretty: 'App Microsurvey', category: '', tags: ['icon'] },
  { name: 'app_moments_filled', pretty: 'App Moments Filled', category: '', tags: ['icon'] },
  { name: 'app_moments', pretty: 'App Moments', category: '', tags: ['icon'] },
  { name: 'app_reporting_filled', pretty: 'App Reporting Filled', category: '', tags: ['icon'] },
  { name: 'app_reporting', pretty: 'App Reporting', category: '', tags: ['icon'] },
  { name: 'app_resolve_filled', pretty: 'App Resolve Filled', category: '', tags: ['icon'] },
  { name: 'app_resolve', pretty: 'App Resolve', category: '', tags: ['icon'] },
  { name: 'app_review_trackers_filled', pretty: 'App Review Trackers Filled', category: '', tags: ['icon'] },
  { name: 'app_review_trackers', pretty: 'App Review Trackers', category: '', tags: ['icon'] },
  { name: 'app_seo_filled', pretty: 'App Seo Filled', category: '', tags: ['icon'] },
  { name: 'app_seo', pretty: 'App Seo', category: '', tags: ['icon'] },
  { name: 'app_spotlight', pretty: 'App Spotlight', category: '', tags: ['icon'] },
  { name: 'app_summary_filled', pretty: 'App Summary Filled', category: '', tags: ['icon'] },
  { name: 'app_summary', pretty: 'App Summary', category: '', tags: ['icon'] },
  { name: 'app_textAnalytics_filled', pretty: 'App TextAnalytics Filled', category: '', tags: ['icon'] },
  { name: 'app_textAnalytics', pretty: 'App TextAnalytics', category: '', tags: ['icon'] },
  { name: 'apps', pretty: 'Apps', category: '', tags: ['icon'] },
  { name: 'arrow_down', pretty: 'Arrow Down', category: '', tags: ['icon'] },
  { name: 'arrow_left', pretty: 'Arrow Left', category: '', tags: ['icon'] },
  { name: 'arrow_link', pretty: 'Arrow Link', category: '', tags: ['icon'] },
  { name: 'arrow_right', pretty: 'Arrow Right', category: '', tags: ['icon'] },
  { name: 'arrow_up', pretty: 'Arrow UP', category: '', tags: ['icon'] },
  { name: 'asterisk', pretty: 'Asterisk', category: '', tags: ['icon'] },
  { name: 'attach', pretty: 'Attach', category: '', tags: ['icon'] },
  { name: 'average_count', pretty: 'Average Count', category: '', tags: ['icon'] },
  { name: 'average', pretty: 'Average', category: '', tags: ['icon'] },
  { name: 'award_filled', pretty: 'Award Filled', category: '', tags: ['icon'] },
  { name: 'award', pretty: 'Award', category: '', tags: ['icon'] },
  { name: 'bar_chart_filled', pretty: 'Bar Chart Filled', category: '', tags: ['icon'] },
  { name: 'bar_chart', pretty: 'Bar Chart', category: '', tags: ['icon'] },
  { name: 'barometer_filled', pretty: 'Barometer Filled', category: '', tags: ['icon'] },
  { name: 'barometer', pretty: 'Barometer', category: '', tags: ['icon'] },
  { name: 'brackets', pretty: 'Brackets', category: '', tags: ['icon'] },
  { name: 'brand_survey_filled', pretty: 'Brand Survey Filled', category: '', tags: ['icon'] },
  { name: 'brand_survey', pretty: 'Brand Survey', category: '', tags: ['icon'] },
  { name: 'calendar_filled', pretty: 'Calendar Filled', category: '', tags: ['icon'] },
  { name: 'calendar', pretty: 'Calendar', category: '', tags: ['icon'] },
  { name: 'cancel_18', pretty: 'Cancel 18', category: '', tags: ['icon'] },
  { name: 'cancel_circle_filled', pretty: 'Cancel Circle Filled', category: '', tags: ['icon'] },
  { name: 'cancel_circle', pretty: 'Cancel Circle', category: '', tags: ['icon'] },
  { name: 'cancel', pretty: 'Cancel', category: '', tags: ['icon'] },
  { name: 'case_complete_filled', pretty: 'Case Complete Filled', category: '', tags: ['icon'] },
  { name: 'case_complete', pretty: 'Case Complete', category: '', tags: ['icon'] },
  { name: 'case_create_filled', pretty: 'Case Create Filled', category: '', tags: ['icon'] },
  { name: 'case_create', pretty: 'Case Create', category: '', tags: ['icon'] },
  { name: 'case_filled', pretty: 'Case Filled', category: '', tags: ['icon'] },
  { name: 'case', pretty: 'Case', category: '', tags: ['icon'] },
  { name: 'case_remove_filled', pretty: 'Case Remove Filled', category: '', tags: ['icon'] },
  { name: 'case_remove', pretty: 'Case Remove', category: '', tags: ['icon'] },
  { name: 'category_closed', pretty: 'Category Closed', category: '', tags: ['icon'] },
  { name: 'category_open', pretty: 'Category Open', category: '', tags: ['icon'] },
  { name: 'certificate_filled', pretty: 'Certificate Filled', category: '', tags: ['icon'] },
  { name: 'certificate', pretty: 'Certificate', category: '', tags: ['icon'] },
  { name: 'chart_1', pretty: 'Chart 1', category: '', tags: ['icon'] },
  { name: 'chart_filled_1', pretty: 'Chart Filled 1', category: '', tags: ['icon'] },
  { name: 'chart_filled', pretty: 'Chart Filled', category: '', tags: ['icon'] },
  { name: 'chart_horizontal_filled', pretty: 'Chart Horizontal Filled', category: '', tags: ['icon'] },
  { name: 'chart_horizontal', pretty: 'Chart Horizontal', category: '', tags: ['icon'] },
  { name: 'chart', pretty: 'Chart', category: '', tags: ['icon'] },
  { name: 'check', pretty: 'Check', category: '', tags: ['icon'] },
  { name: 'checkmark_18', pretty: 'Checkmark 18', category: '', tags: ['icon'] },
  { name: 'checkmark', pretty: 'Checkmark', category: '', tags: ['icon'] },
  { name: 'circle_arrow_down_filled', pretty: 'Circle Arrow Down Filled', category: '', tags: ['icon'] },
  { name: 'circle_arrow_down', pretty: 'Circle Arrow Down', category: '', tags: ['icon'] },
  { name: 'circle_arrow_left_filled', pretty: 'Circle Arrow Left Filled', category: '', tags: ['icon'] },
  { name: 'circle_arrow_left', pretty: 'Circle Arrow Left', category: '', tags: ['icon'] },
  { name: 'circle_arrow_right_filled', pretty: 'Circle Arrow Right Filled', category: '', tags: ['icon'] },
  { name: 'circle_arrow_right', pretty: 'Circle Arrow Right', category: '', tags: ['icon'] },
  { name: 'circle_arrow_up_filled', pretty: 'Circle Arrow UP Filled', category: '', tags: ['icon'] },
  { name: 'circle_arrow_up', pretty: 'Circle Arrow UP', category: '', tags: ['icon'] },
  { name: 'circle_check_filled', pretty: 'Circle Check Filled', category: '', tags: ['icon'] },
  { name: 'circle_check', pretty: 'Circle Check', category: '', tags: ['icon'] },
  { name: 'circle_navigation_filled', pretty: 'Circle Navigation Filled', category: '', tags: ['icon'] },
  { name: 'circle_navigation', pretty: 'Circle Navigation', category: '', tags: ['icon'] },
  { name: 'city', pretty: 'City', category: '', tags: ['icon'] },
  { name: 'clipboard_2', pretty: 'Clipboard 2', category: '', tags: ['icon'] },
  { name: 'clipboard', pretty: 'Clipboard', category: '', tags: ['icon'] },
  { name: 'clock_2_filled', pretty: 'Clock 2 Filled', category: '', tags: ['icon'] },
  { name: 'clock_2', pretty: 'Clock 2', category: '', tags: ['icon'] },
  { name: 'clock_filled', pretty: 'Clock Filled', category: '', tags: ['icon'] },
  { name: 'clock', pretty: 'Clock', category: '', tags: ['icon'] },
  { name: 'coaching_filled', pretty: 'Coaching Filled', category: '', tags: ['icon'] },
  { name: 'coaching', pretty: 'Coaching', category: '', tags: ['icon'] },
  { name: 'collections_filled', pretty: 'Collections Filled', category: '', tags: ['icon'] },
  { name: 'collections', pretty: 'Collections', category: '', tags: ['icon'] },
  { name: 'comment_filled', pretty: 'Comment Filled', category: '', tags: ['icon'] },
  { name: 'comment', pretty: 'Comment', category: '', tags: ['icon'] },
  { name: 'community_filled', pretty: 'Community Filled', category: '', tags: ['icon'] },
  { name: 'community', pretty: 'Community', category: '', tags: ['icon'] },
  { name: 'condensed_card_filled', pretty: 'Condensed Card Filled', category: '', tags: ['icon'] },
  { name: 'condensed_card', pretty: 'Condensed Card', category: '', tags: ['icon'] },
  { name: 'convert', pretty: 'Convert', category: '', tags: ['icon'] },
  { name: 'cookies_filled', pretty: 'Cookies Filled', category: '', tags: ['icon'] },
  { name: 'cookies', pretty: 'Cookies', category: '', tags: ['icon'] },
  { name: 'copy_filled', pretty: 'Copy Filled', category: '', tags: ['icon'] },
  { name: 'copy', pretty: 'Copy', category: '', tags: ['icon'] },
  { name: 'count', pretty: 'Count', category: '', tags: ['icon'] },
  { name: 'crosstab_filled', pretty: 'Crosstab Filled', category: '', tags: ['icon'] },
  { name: 'crosstab', pretty: 'Crosstab', category: '', tags: ['icon'] },
  { name: 'dark_filled', pretty: 'Dark Filled', category: '', tags: ['icon'] },
  { name: 'dark', pretty: 'Dark', category: '', tags: ['icon'] },
  { name: 'database_connect', pretty: 'Database Connect', category: '', tags: ['icon'] },
  { name: 'database', pretty: 'Database', category: '', tags: ['icon'] },
  { name: 'day_filled', pretty: 'Day Filled', category: '', tags: ['icon'] },
  { name: 'day', pretty: 'Day', category: '', tags: ['icon'] },
  { name: 'desktop_filled', pretty: 'Desktop Filled', category: '', tags: ['icon'] },
  { name: 'desktop', pretty: 'Desktop', category: '', tags: ['icon'] },
  { name: 'disable', pretty: 'Disable', category: '', tags: ['icon'] },
  { name: 'distinct_count', pretty: 'Distinct Count', category: '', tags: ['icon'] },
  { name: 'divide_filled', pretty: 'Divide Filled', category: '', tags: ['icon'] },
  { name: 'divide', pretty: 'Divide', category: '', tags: ['icon'] },
  { name: 'document_alert_filled', pretty: 'Document Alert Filled', category: '', tags: ['icon'] },
  { name: 'document_alert', pretty: 'Document Alert', category: '', tags: ['icon'] },
  { name: 'document_bar_chart_filled', pretty: 'Document Bar Chart Filled', category: '', tags: ['icon'] },
  { name: 'document_bar_chart', pretty: 'Document Bar Chart', category: '', tags: ['icon'] },
  { name: 'document_chart_filled', pretty: 'Document Chart Filled', category: '', tags: ['icon'] },
  { name: 'document_chart', pretty: 'Document Chart', category: '', tags: ['icon'] },
  { name: 'document_coach_filled', pretty: 'Document Coach Filled', category: '', tags: ['icon'] },
  { name: 'document_coach', pretty: 'Document Coach', category: '', tags: ['icon'] },
  { name: 'document_comment_filled', pretty: 'Document Comment Filled', category: '', tags: ['icon'] },
  { name: 'document_comment', pretty: 'Document Comment', category: '', tags: ['icon'] },
  { name: 'document_crosstab_filled', pretty: 'Document Crosstab Filled', category: '', tags: ['icon'] },
  { name: 'document_crosstab', pretty: 'Document Crosstab', category: '', tags: ['icon'] },
  { name: 'document_dashboard_filled', pretty: 'Document Dashboard Filled', category: '', tags: ['icon'] },
  { name: 'document_dashboard', pretty: 'Document Dashboard', category: '', tags: ['icon'] },
  { name: 'document_export_filled', pretty: 'Document Export Filled', category: '', tags: ['icon'] },
  { name: 'document_export', pretty: 'Document Export', category: '', tags: ['icon'] },
  { name: 'document_ext_csv', pretty: 'Document Ext Csv', category: '', tags: ['icon'] },
  { name: 'document_ext_excel_filled', pretty: 'Document Ext Excel Filled', category: '', tags: ['icon'] },
  { name: 'document_ext_excel', pretty: 'Document Ext Excel', category: '', tags: ['icon'] },
  { name: 'document_ext_pdf_filled', pretty: 'Document Ext Pdf Filled', category: '', tags: ['icon'] },
  { name: 'document_ext_pdf', pretty: 'Document Ext Pdf', category: '', tags: ['icon'] },
  { name: 'document_ext_txt', pretty: 'Document Ext Txt', category: '', tags: ['icon'] },
  { name: 'document_ext_xlm', pretty: 'Document Ext Xlm', category: '', tags: ['icon'] },
  { name: 'document_ext_xls', pretty: 'Document Ext Xls', category: '', tags: ['icon'] },
  { name: 'document_ext_xml_filled', pretty: 'Document Ext Xml Filled', category: '', tags: ['icon'] },
  { name: 'document_ext_xml', pretty: 'Document Ext Xml', category: '', tags: ['icon'] },
  { name: 'document_field_reporting_filled', pretty: 'Document Field Reporting Filled', category: '', tags: ['icon'] },
  { name: 'document_field_reporting', pretty: 'Document Field Reporting', category: '', tags: ['icon'] },
  { name: 'document_filled', pretty: 'Document Filled', category: '', tags: ['icon'] },
  { name: 'document', pretty: 'Document', category: '', tags: ['icon'] },
  { name: 'document_multiple_checked_filled', pretty: 'Document Multiple Checked Filled', category: '', tags: ['icon'] },
  { name: 'document_multiple_checked', pretty: 'Document Multiple Checked', category: '', tags: ['icon'] },
  { name: 'document_multiple_filled', pretty: 'Document Multiple Filled', category: '', tags: ['icon'] },
  { name: 'document_multiple', pretty: 'Document Multiple', category: '', tags: ['icon'] },
  { name: 'document_report_filled', pretty: 'Document Report Filled', category: '', tags: ['icon'] },
  { name: 'document_report', pretty: 'Document Report', category: '', tags: ['icon'] },
  { name: 'document_resolve_filled', pretty: 'Document Resolve Filled', category: '', tags: ['icon'] },
  { name: 'document_resolve', pretty: 'Document Resolve', category: '', tags: ['icon'] },
  { name: 'document_scorecard_filled', pretty: 'Document Scorecard Filled', category: '', tags: ['icon'] },
  { name: 'document_scorecard', pretty: 'Document Scorecard', category: '', tags: ['icon'] },
  { name: 'document_settings_filled', pretty: 'Document Settings Filled', category: '', tags: ['icon'] },
  { name: 'document_settings', pretty: 'Document Settings', category: '', tags: ['icon'] },
  { name: 'document_survey_filled', pretty: 'Document Survey Filled', category: '', tags: ['icon'] },
  { name: 'document_survey', pretty: 'Document Survey', category: '', tags: ['icon'] },
  { name: 'document_trend_filled', pretty: 'Document Trend Filled', category: '', tags: ['icon'] },
  { name: 'document_trend', pretty: 'Document Trend', category: '', tags: ['icon'] },
  { name: 'download', pretty: 'Download', category: '', tags: ['icon'] },
  { name: 'drag_handle', pretty: 'Drag Handle', category: '', tags: ['icon'] },
  { name: 'edit_filled', pretty: 'Edit Filled', category: '', tags: ['icon'] },
  { name: 'edit', pretty: 'Edit', category: '', tags: ['icon'] },
  { name: 'edit_text_filled', pretty: 'Edit Text Filled', category: '', tags: ['icon'] },
  { name: 'edit_text', pretty: 'Edit Text', category: '', tags: ['icon'] },
  { name: 'email_add_filled', pretty: 'Email Add Filled', category: '', tags: ['icon'] },
  { name: 'email_add', pretty: 'Email Add', category: '', tags: ['icon'] },
  { name: 'email_checked_filled', pretty: 'Email Checked Filled', category: '', tags: ['icon'] },
  { name: 'email_checked', pretty: 'Email Checked', category: '', tags: ['icon'] },
  { name: 'email_edit_filled', pretty: 'Email Edit Filled', category: '', tags: ['icon'] },
  { name: 'email_edit', pretty: 'Email Edit', category: '', tags: ['icon'] },
  { name: 'email_filled', pretty: 'Email Filled', category: '', tags: ['icon'] },
  { name: 'email_location_filled_2', pretty: 'Email Location Filled 2', category: '', tags: ['icon'] },
  { name: 'email_location_filled', pretty: 'Email Location Filled', category: '', tags: ['icon'] },
  { name: 'email_location', pretty: 'Email Location', category: '', tags: ['icon'] },
  { name: 'email', pretty: 'Email', category: '', tags: ['icon'] },
  { name: 'email_open_filled', pretty: 'Email Open Filled', category: '', tags: ['icon'] },
  { name: 'email_open', pretty: 'Email Open', category: '', tags: ['icon'] },
  { name: 'email_remove_filled', pretty: 'Email Remove Filled', category: '', tags: ['icon'] },
  { name: 'email_remove', pretty: 'Email Remove', category: '', tags: ['icon'] },
  { name: 'email_search_filled', pretty: 'Email Search Filled', category: '', tags: ['icon'] },
  { name: 'email_search', pretty: 'Email Search', category: '', tags: ['icon'] },
  { name: 'email_send_filled', pretty: 'Email Send Filled', category: '', tags: ['icon'] },
  { name: 'email_send', pretty: 'Email Send', category: '', tags: ['icon'] },
  { name: 'email_settings_filled', pretty: 'Email Settings Filled', category: '', tags: ['icon'] },
  { name: 'email_settings', pretty: 'Email Settings', category: '', tags: ['icon'] },
  { name: 'enable', pretty: 'Enable', category: '', tags: ['icon'] },
  { name: 'equal', pretty: 'Equal', category: '', tags: ['icon'] },
  { name: 'exchange', pretty: 'Exchange', category: '', tags: ['icon'] },
  { name: 'exit_filled', pretty: 'Exit Filled', category: '', tags: ['icon'] },
  { name: 'exit', pretty: 'Exit', category: '', tags: ['icon'] },
  { name: 'external_link_filled', pretty: 'External Link Filled', category: '', tags: ['icon'] },
  { name: 'external_link', pretty: 'External Link', category: '', tags: ['icon'] },
  { name: 'eye_scan_filled', pretty: 'Eye Scan Filled', category: '', tags: ['icon'] },
  { name: 'eye_scan', pretty: 'Eye Scan', category: '', tags: ['icon'] },
  { name: 'fab_plus', pretty: 'Fab Plus', category: '', tags: ['icon'] },
  { name: 'favorite_filled', pretty: 'Favorite Filled', category: '', tags: ['icon'] },
  { name: 'favorite', pretty: 'Favorite', category: '', tags: ['icon'] },
  { name: 'feedback_filled', pretty: 'Feedback Filled', category: '', tags: ['icon'] },
  { name: 'feedback', pretty: 'Feedback', category: '', tags: ['icon'] },
  { name: 'filter_add_filled', pretty: 'Filter Add Filled', category: '', tags: ['icon'] },
  { name: 'filter_add', pretty: 'Filter Add', category: '', tags: ['icon'] },
  { name: 'filter_filled', pretty: 'Filter Filled', category: '', tags: ['icon'] },
  { name: 'filter', pretty: 'Filter', category: '', tags: ['icon'] },
  { name: 'filter_remove_filled', pretty: 'Filter Remove Filled', category: '', tags: ['icon'] },
  { name: 'filter_remove', pretty: 'Filter Remove', category: '', tags: ['icon'] },
  { name: 'flag_filled', pretty: 'Flag Filled', category: '', tags: ['icon'] },
  { name: 'flag', pretty: 'Flag', category: '', tags: ['icon'] },
  { name: 'folder_filled', pretty: 'Folder Filled', category: '', tags: ['icon'] },
  { name: 'folder', pretty: 'Folder', category: '', tags: ['icon'] },
  { name: 'folder_private_filled', pretty: 'Folder Private Filled', category: '', tags: ['icon'] },
  { name: 'folder_private', pretty: 'Folder Private', category: '', tags: ['icon'] },
  { name: 'forward_30', pretty: 'Forward 30', category: '', tags: ['icon'] },
  { name: 'full_screen', pretty: 'Full Screen', category: '', tags: ['icon'] },
  { name: 'full_story', pretty: 'Full Story', category: '', tags: ['icon'] },
  { name: 'funnel_chart_filled', pretty: 'Funnel Chart Filled', category: '', tags: ['icon'] },
  { name: 'funnel_chart', pretty: 'Funnel Chart', category: '', tags: ['icon'] },
  { name: 'game_filled', pretty: 'Game Filled', category: '', tags: ['icon'] },
  { name: 'game', pretty: 'Game', category: '', tags: ['icon'] },
  { name: 'gender_female', pretty: 'Gender Female', category: '', tags: ['icon'] },
  { name: 'gender_male', pretty: 'Gender Male', category: '', tags: ['icon'] },
  { name: 'gender', pretty: 'Gender', category: '', tags: ['icon'] },
  { name: 'globe_filled', pretty: 'Globe Filled', category: '', tags: ['icon'] },
  { name: 'globe', pretty: 'Globe', category: '', tags: ['icon'] },
  { name: 'globe_warning', pretty: 'Globe Warning', category: '', tags: ['icon'] },
  { name: 'greater_than_or_equal_to', pretty: 'Greater Than Or Equal To', category: '', tags: ['icon'] },
  { name: 'grid_view_filled', pretty: 'Grid View Filled', category: '', tags: ['icon'] },
  { name: 'grid_view', pretty: 'Grid View', category: '', tags: ['icon'] },
  { name: 'history', pretty: 'History', category: '', tags: ['icon'] },
  { name: 'hour_glass_filled', pretty: 'Hour Glass Filled', category: '', tags: ['icon'] },
  { name: 'hour_glass', pretty: 'Hour Glass', category: '', tags: ['icon'] },
  { name: 'html', pretty: 'Html', category: '', tags: ['icon'] },
  { name: 'impact_analysis', pretty: 'Impact Analysis', category: '', tags: ['icon'] },
  { name: 'indeterminate_18', pretty: 'Indeterminate 18', category: '', tags: ['icon'] },
  { name: 'indeterminate', pretty: 'Indeterminate', category: '', tags: ['icon'] },
  { name: 'info_filled', pretty: 'Info Filled', category: '', tags: ['icon'] },
  { name: 'info', pretty: 'Info', category: '', tags: ['icon'] },
  { name: 'integrations_filled', pretty: 'Integrations Filled', category: '', tags: ['icon'] },
  { name: 'integrations', pretty: 'Integrations', category: '', tags: ['icon'] },
  { name: 'invalid', pretty: 'Invalid', category: '', tags: ['icon'] },
  { name: 'kabob', pretty: 'Kabob', category: '', tags: ['icon'] },
  { name: 'kitchen_filled', pretty: 'Kitchen Filled', category: '', tags: ['icon'] },
  { name: 'kitchen', pretty: 'Kitchen', category: '', tags: ['icon'] },
  { name: 'less_than_or_equal_to', pretty: 'Less Than Or Equal To', category: '', tags: ['icon'] },
  { name: 'light_filled', pretty: 'Light Filled', category: '', tags: ['icon'] },
  { name: 'light', pretty: 'Light', category: '', tags: ['icon'] },
  { name: 'lightbulb_filled', pretty: 'Lightbulb Filled', category: '', tags: ['icon'] },
  { name: 'lightbulb', pretty: 'Lightbulb', category: '', tags: ['icon'] },
  { name: 'link', pretty: 'Link', category: '', tags: ['icon'] },
  { name: 'list_view', pretty: 'List View', category: '', tags: ['icon'] },
  { name: 'location_filled', pretty: 'Location Filled', category: '', tags: ['icon'] },
  { name: 'location', pretty: 'Location', category: '', tags: ['icon'] },
  { name: 'lodge_filled_1', pretty: 'Lodge Filled 1', category: '', tags: ['icon'] },
  { name: 'lodge_filled_2', pretty: 'Lodge Filled 2', category: '', tags: ['icon'] },
  { name: 'lodge', pretty: 'Lodge', category: '', tags: ['icon'] },
  { name: 'logging_filled', pretty: 'Logging Filled', category: '', tags: ['icon'] },
  { name: 'logging', pretty: 'Logging', category: '', tags: ['icon'] },
  { name: 'mapping_complete_filled', pretty: 'Mapping Complete Filled', category: '', tags: ['icon'] },
  { name: 'mapping_complete', pretty: 'Mapping Complete', category: '', tags: ['icon'] },
  { name: 'mapping', pretty: 'Mapping', category: '', tags: ['icon'] },
  { name: 'market_survey_filled', pretty: 'Market Survey Filled', category: '', tags: ['icon'] },
  { name: 'market_survey', pretty: 'Market Survey', category: '', tags: ['icon'] },
  { name: 'meatball_filled', pretty: 'Meatball Filled', category: '', tags: ['icon'] },
  { name: 'meatball', pretty: 'Meatball', category: '', tags: ['icon'] },
  { name: 'menu', pretty: 'Menu', category: '', tags: ['icon'] },
  { name: 'mobile_filled', pretty: 'Mobile Filled', category: '', tags: ['icon'] },
  { name: 'mobile', pretty: 'Mobile', category: '', tags: ['icon'] },
  { name: 'monitor_filled', pretty: 'Monitor Filled', category: '', tags: ['icon'] },
  { name: 'monitor', pretty: 'Monitor', category: '', tags: ['icon'] },
  { name: 'more_filled', pretty: 'More Filled', category: '', tags: ['icon'] },
  { name: 'more', pretty: 'More', category: '', tags: ['icon'] },
  { name: 'multiple_layer', pretty: 'Multiple Layer', category: '', tags: ['icon'] },
  { name: 'navigation_filled', pretty: 'Navigation Filled', category: '', tags: ['icon'] },
  { name: 'navigation', pretty: 'Navigation', category: '', tags: ['icon'] },
  { name: 'new_window_filled', pretty: 'New Window Filled', category: '', tags: ['icon'] },
  { name: 'new_window', pretty: 'New Window', category: '', tags: ['icon'] },
  { name: 'no_icon', pretty: 'NO Icon', category: '', tags: ['icon'] },
  { name: 'not_equal_to', pretty: 'Not Equal To', category: '', tags: ['icon'] },
  { name: 'notepad_filled', pretty: 'Notepad Filled', category: '', tags: ['icon'] },
  { name: 'notepad', pretty: 'Notepad', category: '', tags: ['icon'] },
  { name: 'notification_filled', pretty: 'Notification Filled', category: '', tags: ['icon'] },
  { name: 'notification', pretty: 'Notification', category: '', tags: ['icon'] },
  { name: 'notification_snooze_filled', pretty: 'Notification Snooze Filled', category: '', tags: ['icon'] },
  { name: 'notification_snooze', pretty: 'Notification Snooze', category: '', tags: ['icon'] },
  { name: 'notifications_off_filled', pretty: 'Notifications Off Filled', category: '', tags: ['icon'] },
  { name: 'notifications_off', pretty: 'Notifications Off', category: '', tags: ['icon'] },
  { name: 'organization_filled', pretty: 'Organization Filled', category: '', tags: ['icon'] },
  { name: 'organization', pretty: 'Organization', category: '', tags: ['icon'] },
  { name: 'page_count_filled', pretty: 'Page Count Filled', category: '', tags: ['icon'] },
  { name: 'page_count', pretty: 'Page Count', category: '', tags: ['icon'] },
  { name: 'parentheses', pretty: 'Parentheses', category: '', tags: ['icon'] },
  { name: 'password_filled', pretty: 'Password Filled', category: '', tags: ['icon'] },
  { name: 'password', pretty: 'Password', category: '', tags: ['icon'] },
  { name: 'password_open_filled', pretty: 'Password Open Filled', category: '', tags: ['icon'] },
  { name: 'password_open', pretty: 'Password Open', category: '', tags: ['icon'] },
  { name: 'pause_filled', pretty: 'Pause Filled', category: '', tags: ['icon'] },
  { name: 'pause', pretty: 'Pause', category: '', tags: ['icon'] },
  { name: 'percentage', pretty: 'Percentage', category: '', tags: ['icon'] },
  { name: 'permission_filled', pretty: 'Permission Filled', category: '', tags: ['icon'] },
  { name: 'permission', pretty: 'Permission', category: '', tags: ['icon'] },
  { name: 'photo_filled', pretty: 'Photo Filled', category: '', tags: ['icon'] },
  { name: 'photo', pretty: 'Photo', category: '', tags: ['icon'] },
  { name: 'pie_chart_filled', pretty: 'Pie Chart Filled', category: '', tags: ['icon'] },
  { name: 'pie_chart', pretty: 'Pie Chart', category: '', tags: ['icon'] },
  { name: 'pin_filled', pretty: 'Pin Filled', category: '', tags: ['icon'] },
  { name: 'pin', pretty: 'Pin', category: '', tags: ['icon'] },
  { name: 'play_control_filled', pretty: 'Play Control Filled', category: '', tags: ['icon'] },
  { name: 'play_control', pretty: 'Play Control', category: '', tags: ['icon'] },
  { name: 'play_filled', pretty: 'Play Filled', category: '', tags: ['icon'] },
  { name: 'play', pretty: 'Play', category: '', tags: ['icon'] },
  { name: 'plus', pretty: 'Plus', category: '', tags: ['icon'] },
  { name: 'preview_filled', pretty: 'Preview Filled', category: '', tags: ['icon'] },
  { name: 'preview', pretty: 'Preview', category: '', tags: ['icon'] },
  { name: 'previous_page_filled', pretty: 'Previous Page Filled', category: '', tags: ['icon'] },
  { name: 'previous_page', pretty: 'Previous Page', category: '', tags: ['icon'] },
  { name: 'print_filled', pretty: 'Print Filled', category: '', tags: ['icon'] },
  { name: 'print', pretty: 'Print', category: '', tags: ['icon'] },
  { name: 'product_survey_filled', pretty: 'Product Survey Filled', category: '', tags: ['icon'] },
  { name: 'product_survey', pretty: 'Product Survey', category: '', tags: ['icon'] },
  { name: 'quantum_metric', pretty: 'Quantum Metric', category: '', tags: ['icon'] },
  { name: 'question_mark', pretty: 'Question Mark', category: '', tags: ['icon'] },
  { name: 'receipt_filled', pretty: 'Receipt Filled', category: '', tags: ['icon'] },
  { name: 'receipt', pretty: 'Receipt', category: '', tags: ['icon'] },
  { name: 'refresh', pretty: 'Refresh', category: '', tags: ['icon'] },
  { name: 'regional_summary_filled', pretty: 'Regional Summary Filled', category: '', tags: ['icon'] },
  { name: 'regional_summary', pretty: 'Regional Summary', category: '', tags: ['icon'] },
  { name: 'remove_circle_filled', pretty: 'Remove Circle Filled', category: '', tags: ['icon'] },
  { name: 'remove_circle', pretty: 'Remove Circle', category: '', tags: ['icon'] },
  { name: 'reply', pretty: 'Reply', category: '', tags: ['icon'] },
  { name: 'reporting_filled', pretty: 'Reporting Filled', category: '', tags: ['icon'] },
  { name: 'reporting', pretty: 'Reporting', category: '', tags: ['icon'] },
  { name: 'research_panel_filled', pretty: 'Research Panel Filled', category: '', tags: ['icon'] },
  { name: 'research_panel', pretty: 'Research Panel', category: '', tags: ['icon'] },
  { name: 'rewind_15', pretty: 'Rewind 15', category: '', tags: ['icon'] },
  { name: 'rocket_filled', pretty: 'Rocket Filled', category: '', tags: ['icon'] },
  { name: 'rocket', pretty: 'Rocket', category: '', tags: ['icon'] },
  { name: 'role_filled', pretty: 'Role Filled', category: '', tags: ['icon'] },
  { name: 'role', pretty: 'Role', category: '', tags: ['icon'] },
  { name: 'save_filled', pretty: 'Save Filled', category: '', tags: ['icon'] },
  { name: 'save', pretty: 'Save', category: '', tags: ['icon'] },
  { name: 'saved_views_filled', pretty: 'Saved Views Filled', category: '', tags: ['icon'] },
  { name: 'saved_views', pretty: 'Saved Views', category: '', tags: ['icon'] },
  { name: 'scale_filled', pretty: 'Scale Filled', category: '', tags: ['icon'] },
  { name: 'scale', pretty: 'Scale', category: '', tags: ['icon'] },
  { name: 'schedule_filled', pretty: 'Schedule Filled', category: '', tags: ['icon'] },
  { name: 'schedule', pretty: 'Schedule', category: '', tags: ['icon'] },
  { name: 'search_filled', pretty: 'Search Filled', category: '', tags: ['icon'] },
  { name: 'search', pretty: 'Search', category: '', tags: ['icon'] },
  { name: 'search_suggestion_filled', pretty: 'Search Suggestion Filled', category: '', tags: ['icon'] },
  { name: 'search_suggestion', pretty: 'Search Suggestion', category: '', tags: ['icon'] },
  { name: 'sentiment_negative_filled', pretty: 'Sentiment Negative Filled', category: '', tags: ['icon'] },
  { name: 'sentiment_negative', pretty: 'Sentiment Negative', category: '', tags: ['icon'] },
  { name: 'sentiment_neutral_filled', pretty: 'Sentiment Neutral Filled', category: '', tags: ['icon'] },
  { name: 'sentiment_neutral', pretty: 'Sentiment Neutral', category: '', tags: ['icon'] },
  { name: 'sentiment_positive_filled', pretty: 'Sentiment Positive Filled', category: '', tags: ['icon'] },
  { name: 'sentiment_positive', pretty: 'Sentiment Positive', category: '', tags: ['icon'] },
  { name: 'settings_filled', pretty: 'Settings Filled', category: '', tags: ['icon'] },
  { name: 'settings', pretty: 'Settings', category: '', tags: ['icon'] },
  { name: 'share_filled', pretty: 'Share Filled', category: '', tags: ['icon'] },
  { name: 'share', pretty: 'Share', category: '', tags: ['icon'] },
  { name: 'shield_filled', pretty: 'Shield Filled', category: '', tags: ['icon'] },
  { name: 'shield', pretty: 'Shield', category: '', tags: ['icon'] },
  { name: 'shield_remove_filled', pretty: 'Shield Remove Filled', category: '', tags: ['icon'] },
  { name: 'shield_remove', pretty: 'Shield Remove', category: '', tags: ['icon'] },
  { name: 'shipping_filled', pretty: 'Shipping Filled', category: '', tags: ['icon'] },
  { name: 'shipping', pretty: 'Shipping', category: '', tags: ['icon'] },
  { name: 'signature_filled', pretty: 'Signature Filled', category: '', tags: ['icon'] },
  { name: 'signature', pretty: 'Signature', category: '', tags: ['icon'] },
  { name: 'single_arrow_down', pretty: 'Single Arrow Down', category: '', tags: ['icon'] },
  { name: 'single_arrow_left', pretty: 'Single Arrow Left', category: '', tags: ['icon'] },
  { name: 'single_arrow_right', pretty: 'Single Arrow Right', category: '', tags: ['icon'] },
  { name: 'single_arrow_up', pretty: 'Single Arrow UP', category: '', tags: ['icon'] },
  { name: 'single_layer', pretty: 'Single Layer', category: '', tags: ['icon'] },
  { name: 'small_circle_filled', pretty: 'Small Circle Filled', category: '', tags: ['icon'] },
  { name: 'small_circle', pretty: 'Small Circle', category: '', tags: ['icon'] },
  { name: 'small_down_triangle_filled', pretty: 'Small Down Triangle Filled', category: '', tags: ['icon'] },
  { name: 'small_down_triangle', pretty: 'Small Down Triangle', category: '', tags: ['icon'] },
  { name: 'small_left_triangle_filled', pretty: 'Small Left Triangle Filled', category: '', tags: ['icon'] },
  { name: 'small_left_triangle', pretty: 'Small Left Triangle', category: '', tags: ['icon'] },
  { name: 'small_right_triangle_filled', pretty: 'Small Right Triangle Filled', category: '', tags: ['icon'] },
  { name: 'small_right_triangle', pretty: 'Small Right Triangle', category: '', tags: ['icon'] },
  { name: 'small_up_triangle_filled', pretty: 'Small UP Triangle Filled', category: '', tags: ['icon'] },
  { name: 'small_up_triangle', pretty: 'Small UP Triangle', category: '', tags: ['icon'] },
  { name: 'sort', pretty: 'Sort', category: '', tags: ['icon'] },
  { name: 'sort_most_relevant', pretty: 'Sort Most Relevant', category: '', tags: ['icon'] },
  { name: 'sort_order_asc', pretty: 'Sort Order Asc', category: '', tags: ['icon'] },
  { name: 'sort_order_desc', pretty: 'Sort Order Desc', category: '', tags: ['icon'] },
  { name: 'split_filled', pretty: 'Split Filled', category: '', tags: ['icon'] },
  { name: 'split', pretty: 'Split', category: '', tags: ['icon'] },
  { name: 'stacked_columns', pretty: 'Stacked Columns', category: '', tags: ['icon'] },
  { name: 'stacked_rows', pretty: 'Stacked Rows', category: '', tags: ['icon'] },
  { name: 'star_filled', pretty: 'Star Filled', category: '', tags: ['icon'] },
  { name: 'star', pretty: 'Star', category: '', tags: ['icon'] },
  { name: 'stethoscope_filled', pretty: 'Stethoscope Filled', category: '', tags: ['icon'] },
  { name: 'stethoscope', pretty: 'Stethoscope', category: '', tags: ['icon'] },
  { name: 'style_filled', pretty: 'Style Filled', category: '', tags: ['icon'] },
  { name: 'style', pretty: 'Style', category: '', tags: ['icon'] },
  { name: 'support_filled', pretty: 'Support Filled', category: '', tags: ['icon'] },
  { name: 'support', pretty: 'Support', category: '', tags: ['icon'] },
  { name: 'survey_authoring_filled', pretty: 'Survey Authoring Filled', category: '', tags: ['icon'] },
  { name: 'survey_authoring', pretty: 'Survey Authoring', category: '', tags: ['icon'] },
  { name: 'tag_filled', pretty: 'Tag Filled', category: '', tags: ['icon'] },
  { name: 'tag', pretty: 'Tag', category: '', tags: ['icon'] },
  { name: 'text_formatting', pretty: 'Text Formatting', category: '', tags: ['icon'] },
  { name: 'theme_filled', pretty: 'Theme Filled', category: '', tags: ['icon'] },
  { name: 'theme', pretty: 'Theme', category: '', tags: ['icon'] },
  { name: 'time_filled', pretty: 'Time Filled', category: '', tags: ['icon'] },
  { name: 'time', pretty: 'Time', category: '', tags: ['icon'] },
  { name: 'tools_filled', pretty: 'Tools Filled', category: '', tags: ['icon'] },
  { name: 'tools', pretty: 'Tools', category: '', tags: ['icon'] },
  { name: 'translation_filled', pretty: 'Translation Filled', category: '', tags: ['icon'] },
  { name: 'translation', pretty: 'Translation', category: '', tags: ['icon'] },
  { name: 'trash_filled', pretty: 'Trash Filled', category: '', tags: ['icon'] },
  { name: 'trash', pretty: 'Trash', category: '', tags: ['icon'] },
  { name: 'tree_picker_collapse', pretty: 'Tree Picker Collapse', category: '', tags: ['icon'] },
  { name: 'tree_picker_expand', pretty: 'Tree Picker Expand', category: '', tags: ['icon'] },
  { name: 'trend_flatten', pretty: 'Trend Flatten', category: '', tags: ['icon'] },
  { name: 'trend_increase', pretty: 'Trend Increase', category: '', tags: ['icon'] },
  { name: 'unassigned_filled', pretty: 'Unassigned Filled', category: '', tags: ['icon'] },
  { name: 'unassigned', pretty: 'Unassigned', category: '', tags: ['icon'] },
  { name: 'upload', pretty: 'Upload', category: '', tags: ['icon'] },
  { name: 'user_female_filled_1', pretty: 'User Female Filled 1', category: '', tags: ['icon'] },
  { name: 'user_female_filled_2', pretty: 'User Female Filled 2', category: '', tags: ['icon'] },
  { name: 'user_female', pretty: 'User Female', category: '', tags: ['icon'] },
  { name: 'user_male_filled_1', pretty: 'User Male Filled 1', category: '', tags: ['icon'] },
  { name: 'user_male_filled_2', pretty: 'User Male Filled 2', category: '', tags: ['icon'] },
  { name: 'user_male', pretty: 'User Male', category: '', tags: ['icon'] },
  { name: 'users_filled', pretty: 'Users Filled', category: '', tags: ['icon'] },
  { name: 'users', pretty: 'Users', category: '', tags: ['icon'] },
  { name: 'video_filled', pretty: 'Video Filled', category: '', tags: ['icon'] },
  { name: 'video', pretty: 'Video', category: '', tags: ['icon'] },
  { name: 'view_condensed_filled', pretty: 'View Condensed Filled', category: '', tags: ['icon'] },
  { name: 'view_condensed', pretty: 'View Condensed', category: '', tags: ['icon'] },
  { name: 'view_normal_filled', pretty: 'View Normal Filled', category: '', tags: ['icon'] },
  { name: 'view_normal', pretty: 'View Normal', category: '', tags: ['icon'] },
  { name: 'view_table_filled', pretty: 'View Table Filled', category: '', tags: ['icon'] },
  { name: 'view_table', pretty: 'View Table', category: '', tags: ['icon'] },
  { name: 'visibility_filled', pretty: 'Visibility Filled', category: '', tags: ['icon'] },
  { name: 'visibility', pretty: 'Visibility', category: '', tags: ['icon'] },
  { name: 'visibility_off_filled', pretty: 'Visibility Off Filled', category: '', tags: ['icon'] },
  { name: 'visibility_off', pretty: 'Visibility Off', category: '', tags: ['icon'] },
  { name: 'volume_off_filled', pretty: 'Volume Off Filled', category: '', tags: ['icon'] },
  { name: 'volume_off', pretty: 'Volume Off', category: '', tags: ['icon'] },
  { name: 'volume_on_filled', pretty: 'Volume ON Filled', category: '', tags: ['icon'] },
  { name: 'volume_on', pretty: 'Volume ON', category: '', tags: ['icon'] },
  { name: 'warning_filled', pretty: 'Warning Filled', category: '', tags: ['icon'] },
  { name: 'warning', pretty: 'Warning', category: '', tags: ['icon'] },
  { name: 'width_2', pretty: 'Width 2', category: '', tags: ['icon'] },
  { name: 'width', pretty: 'Width', category: '', tags: ['icon'] },
  { name: 'wifi', pretty: 'Wifi', category: '', tags: ['icon'] },
];
